import axios from "axios";
import AdminService from "@/services/admin.service.js";
export default class Evenement {

    id = "";
    nom = "";
    date_debut = "";
    date_fin = "";
    metadatas = [];

    constructor() { }

    async fetch() {
        let res = await axios.get("/evenement/get.php?id=" + this.id);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            this.set(res.data);
            return await true;
        }
    }

    set(data) {
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                this[key] = value;
            }
        }
    }

    async update_config() {
        let res = await AdminService.updateEventConfig(this);
        return res;
    }
}